module.exports = __webpack_public_path__ + "img/PIX.504472d.png";